import { jsx as _jsx } from "react/jsx-runtime";
import { DepositTxnInfo } from "./txn/DepositTxnInfo";
import { TxnInfoShell } from "./txn/TxnInfoShell";
import { WithdrawalTxnInfo } from "./txn/WithdrawalTxnInfo";
export var TxnInfo = function (_a) {
    var txnId = _a.txnId, token = _a.token, onTxnInfoUpdate = _a.onTxnInfoUpdate;
    return (_jsx(TxnInfoShell, { txnId: txnId, token: token, onTxnInfoUpdate: onTxnInfoUpdate, children: function (info) {
            return info.kind === "deposit" ? (_jsx(DepositTxnInfo, { info: info })) : (_jsx(WithdrawalTxnInfo, { info: info }));
        } }));
};
